"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPartner = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
const enums_1 = require("../enums");
class AddPartner extends common_1.BaseAction {
}
__decorate([
    class_validator_1.IsString()
], AddPartner.prototype, "partnerName", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddPartner.prototype, "partnerDisplayName", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsArray(),
    class_validator_1.IsEnum(enums_1.PartnerType, { each: true })
], AddPartner.prototype, "type", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddPartner.prototype, "address", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    class_validator_1.MaxLength(10)
], AddPartner.prototype, "zip", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddPartner.prototype, "city", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    class_validator_1.MinLength(2),
    class_validator_1.MaxLength(3)
], AddPartner.prototype, "state", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddPartner.prototype, "county", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    class_validator_1.MinLength(2),
    class_validator_1.MaxLength(3)
], AddPartner.prototype, "country", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddPartner.prototype, "attention", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsArray(),
    class_validator_1.IsEnum(enums_1.PartnerAddressType, { each: true })
], AddPartner.prototype, "addressType", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddPartner.prototype, "contactName", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsEmail()
], AddPartner.prototype, "contactEmail", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString()
], AddPartner.prototype, "contactPhone", void 0);
exports.AddPartner = AddPartner;
//# sourceMappingURL=add-partner.action.js.map